import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { AgentProfileForBuyerQuery } from 'interfaceAdapter/queries/AgentProfileForBuyer';
import { IPublicAgent } from 'domain/entities/Agent/Agent';
import { useParams } from 'react-router-dom';

export const useAgentProfile = () => {
    const diContainer = useContext(diContainerContext);
    const agentProfileForBuyerQuery = diContainer.resolve(AgentProfileForBuyerQuery);
    const [agent, setAgent] = useState<IPublicAgent>();
    const params = useParams();

    useEffect(() => {
        if (params.agentId === undefined) {
            return;
        }

        const fetchData = async () => {
            const resAgent = await agentProfileForBuyerQuery.fetch(Number(params.agentId));
            setAgent(resAgent);
        };
        fetchData();
    }, []);

    return {
        agent,
    };
};
